import { render, staticRenderFns } from "./DataBySaler.vue?vue&type=template&id=8bd98788"
import script from "./DataBySaler.vue?vue&type=script&lang=js"
export * from "./DataBySaler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports